// John Eldhose 20180705
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, Snackbar, TextField, Typography } from '@material-ui/core';
import { Email } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { resendverify } from '../Api/resendverify';

class ResendVerify extends Component {

  state = {
    clicked: false,
    email: '',
    emailError: false,
    resendColor: 'red',
    resendHelper: '',
    resendError: false
  }
  handleUserInput (event, lower = false) {
    this.setState({ [event.target.name]: (
      lower ? event.target.value.toLowerCase() : event.target.value
    ) });
    const error = event.target.name + 'Error';
    this.setState({ [error]: false });
  }
  handleChangeEmail = (event) => {
    this.setState({ email: event.target.value })
  }
  handleClickResend = () => {
    this.setState({ clicked: true });
    resendverify(this.state.email)
      .then((resend) => {
        if(resend['status'] === 'true') {
          this.setState({ resendHelper: 'Verify email is sent' });
          this.setState({ resendError: true });
        }
        else {
          let fld = '';
          this.setState({ resendHelper: resend['error'] });
          this.setState({ resendError: true });
          if(resend['fields'].length > 0) {
            resend['fields'].map((field) => {
              fld = field + 'Error';
              this.setState({ [fld]: true });
              return false;
            })
          }
          this.setState({ clicked: false });
        }
      })
      .catch((error) => {
        this.setState({ resendHelper: 'Resend failed' });
        this.setState({ resendError: true });
        this.setState({ clicked: false });
      })
  }
  handleCloseRecovery = () => {
    this.setState({ resendError: false });
  }

  render() {
    return (
      <div>
      <Typography variant='display1'>
        <font color='#385687'>Carlson Customer Login</font>
      </Typography>
        <Typography variant='title'>
          <font color='black'>
            <FormattedMessage
              id='Resend verify email'
              defaultMessage='Resend verify email'
            />
          </font>
        </Typography>
        <p />
        <Typography variant='subheading'>
          <FormattedMessage
            id='Shared between Carlson Cloud, Community, PhotoCapture, and Academy'
            defaultMessage='Shared between Carlson Cloud, Community, PhotoCapture, and Academy'
          />
        </Typography>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Email className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Email address'
                defaultMessage='Email address'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='email'
                    value={this.state.email}
                    error={this.state.emailError}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <Button
          variant='raised'
          color='primary'
          fullWidth
          disabled={this.state.clicked}
          onClick={this.handleClickResend}
        >
          <FormattedMessage
            id='Resend verification email'
            defaultMessage='Resend verification email'
          /> &nbsp;
          <Email />
        </Button>
        <p />
        <Divider />
        <p />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/' fullWidth>
              <FormattedMessage
                id='Return to Login'
                defaultMessage='Return to Login'
              />
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.resendError}
          onClose={this.handleCloseRecovery}
          message={
            <span style={{ color: this.state.resendColor }}>
              {this.state.resendHelper}
            </span>
          }
        />
      </div>
    );
  }
}

export default ResendVerify;



// WEBPACK FOOTER //
// ./src/components/ResendVerify.js